import React, { useEffect } from "react";
import "./MobileDeletePopup.css";
import { FaTrash } from "react-icons/fa";

const MobileDeletePopup = ({ show, onClose, onConfirm }) => {
  // ✅ Disable background scroll when popup is open
  useEffect(() => {
    if (show) document.body.classList.add("popup-open");
    else document.body.classList.remove("popup-open");
  }, [show]);

  if (!show) return null;

  return (
    <div className="mobile-delete-popup-overlay" onClick={onClose}>
      <div
        className="mobile-delete-popup-box"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mobile-delete-popup-header">
          <FaTrash className="delete-icon" />
          <h3>Delete Confirmation</h3>
        </div>

        <p className="mobile-delete-popup-text">
          Are you sure you want to delete this category?
        </p>

        <div className="mobile-delete-popup-actions">
          <button className="mobile-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="mobile-delete-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileDeletePopup;
